export const DEFAULT_INVITE_ROLE_DESCRIPTION = "Recruiter";

export const getDefaultInviteRole = (roles = []) =>
  roles.find((role) => role.description === DEFAULT_INVITE_ROLE_DESCRIPTION);
